import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../../core/services/translation';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex items-center gap-2">
      <button 
        (click)="switchLanguage('it')"
        [class.font-bold]="translation.currentLang() === 'it'"
        class="text-sm hover:text-enduro-orange transition-colors"
        aria-label="Passa alla lingua Italiana"
      >
        IT
      </button>
      <span class="text-gray-400">|</span>
      <button 
        (click)="switchLanguage('en')"
        [class.font-bold]="translation.currentLang() === 'en'"
        class="text-sm hover:text-enduro-orange transition-colors"
        aria-label="Switch to English"
      >
        EN
      </button>
    </div>
  `
})
export class LanguageSwitcherComponent {
  translation = inject(TranslationService);

  switchLanguage(lang: string) {
    this.translation.useLanguage(lang);
    // Reload page to ensure all translations update properly
    window.location.reload();
  }
}
